import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';

export type SignOutClickSource = 'hamburger_menu' | 'header';

const signOutContext = (source: SignOutClickSource): string =>
  source === 'header'
    ? PULSE_CLICK_CATEGORY.HEADER
    : PULSE_CLICK_CATEGORY.HAMBURGER_MENU;

/** Sign out — mobile hamburger sidebar vs desktop header dropdown. */
export const trackSignOutClick = (
  source: SignOutClickSource = 'hamburger_menu',
  page_path?: string
): void => {
  const context = signOutContext(source);
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;

  trackPulseClick({
    category: context,
    action: PULSE_CLICK_ACTION.TAP_SIGN_OUT,
    label: null,
    view_id: context,
    page_id: context,
    page_path: path,
  });
};
